/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

document.addEventListener("DOMContentLoaded", function () {
    window.scrollTo(0, 0); // Ставить скролл на самий верх
});
window.addEventListener("beforeunload", function () {
    window.scrollTo(0, 0); // Ставить скролл на самий верх перед перезавантаженням сторінки
});

window.Vue = require("vue").default;
import vueDebounce from "vue-debounce";

import vSelect from "vue-select";
import Vuex from "vuex";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";

Vue.component("v-select", vSelect);
Vue.use(vueDebounce);
Vue.use(Vuex);
Vue.use(VueToast);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component(
    "master-invoices",
    require("./components/MasterInvoices/index").default
);

Vue.component("address-tab", require("./components/AddressTab/index").default);
Vue.component("deals", require("./components/Deals/index").default);
Vue.component(
    "deals-agency-and-brand",
    require("./components/Deals/AgencyAndBrandForm/index").default
);
Vue.component("agencies", require("./components/Agencies/index").default);
Vue.component(
    "agency-contact-tab",
    require("./components/Agencies/contactTab").default
);
Vue.component(
    "partnerInvoices",
    require("./components/PartnerInvoices/index").default
);
Vue.component("sales", require("./components/Sales/index").default);
Vue.component(
    "referral-partners",
    require("./components/ReferralPartners/index").default
);
Vue.component("partners", require("./components/Partners/index").default);
Vue.component("brands", require("./components/Brands/index").default);
Vue.component("notes", require("./components/Notes/index").default);
Vue.component("new-note", require("./components/Notes/create").default);
Vue.component("edit-note", require("./components/Notes/edit").default);
Vue.component(
    "business-tab",
    require("./components/BusinessTab/index").default
);
Vue.component(
    "documents-tab",
    require("./components/DocumentsTab/index").default
);
Vue.component(
    "partner-contact-tab",
    require("./components/ReferralPartners/contactTab").default
);
Vue.component(
    "services-of-deal",
    require("./components/Deals/ServicesTable/index").default
);

Vue.component(
    "sows-of-deal",
    require("./components/Deals/SOWTable/index").default
);

Vue.component(
    "main-contact-tab",
    require("./components/ContactTab/Index").default
);

Vue.component(
    "sales-services-table",
    require("./components/Sales/ServicesTable/index").default
);

Vue.component(
    "confirm-modal",
    require("./components/ConfirmModal/index").default
);

Vue.component(
    "agency-details-tab",
    require("./components/Agencies/detailsTab").default
);

// Modules

Vue.component(
    "form-viewer-app",
    require("./modules/formViewer/index.vue").default
);

Vue.component(
    "form-constructor-app",
    require("./modules/formConstructor/index.vue").default
);

Vue.component(
    "agency-wizard",
    require("./modules/AgencyWizard/index.vue").default
);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

try {
    if (document.getElementById("app")) {
        new Vue({
            el: "#app",
        });
    }
} catch (err) {
    console.error("App is not defiened", err);
}

import AgencyWizard from "./modules/AgencyWizard/index.vue";

const store = new Vuex.Store({
    state: {
        currentSection: null,
        currentTask: null,
        prevComponent: null,
        salesPages: null,
        salesPagesIndex: 0,
        currentBrandName: "",
        agencyName: "",
        editDealId: null,
        sow_index: 0,
        upsell_index: 0,
        isEditUpsell: false,
        isWithoutSOW: false,
        servicesList: [],

        salesPageDealIndex: 0,
        salesPageSaleIndex: 0,

        isHasKickOff: false,
        isHasUploadLaterSOWs: false,

        isHasDealCanceled: false,
        idSLIWithDealCanceled: null,
        indexSLIWithDealCanceled: null,

        initUploadLaterSOWFromQuery: null,
    },
    getters: {
        getCurrentTask: (state) => state.currentTask,
        getSection: (state) => state.currentSection,
        getPrevComponent: (state) => state.prevComponent,
        getSalesPages: (state) => (index) => state.salesPages[index] || null,
        getAllSalesPages: (state) =>
            state.salesPages && state.salesPages.length > 0
                ? state.salesPages
                : null,
        getSalesPagesIndex: (state) => state.salesPagesIndex || 0,
        getCurrentBrandName: (state) => state.currentBrandName || "",
        getAgencyName: (state) => state.agencyName || "",
        getEditDealId: (state) => state.editDealId || null,
        getCurrentIndexSOW: (state) => state.sow_index || 0,
        getCurrentIndexUpsell: (state) => state.upsell_index || 0,
        getIsEditUpsell: (state) => state.isEditUpsell,
        getIsWithoutSOW: (state) => state.isWithoutSOW || false,
        getServicesList: (state) => state.servicesList || [],

        getDealSalesIndex: (state) => state.salesPageDealIndex,
        getSaleSalesIndex: (state) => state.salesPageSaleIndex,
        getCurrentDealname: (state) => {
            if (state.salesPages) {
                return state.salesPages[state.salesPageDealIndex].deal_name;
            }
            return "";
        },

        getIsHasKickOff: (state) => state.isHasKickOff,

        getIsHasUploadLaterSOWs: (state) => state.isHasUploadLaterSOWs,

        getIsHasCanceledDeal: (state) => state.isHasDealCanceled,
        getIdSLIWithDealCanceled: (state) => state.idSLIWithDealCanceled,
        getIndexSLIWithDealCanceled: (state) => state.indexSLIWithDealCanceled,

        getInitUploadLaterSOWFromQuery: (state) =>
            state.initUploadLaterSOWFromQuery,
    },
    mutations: {
        setPrevComponent(state, action) {
            state.prevComponent = action;
        },
        setCurrentSection(state, action) {
            state.currentSection = action;
        },
        setCurrentTask(state, action = null) {
            state.currentTask = action;
        },
        setSalesPages(state, action) {
            state.salesPages = action;
        },
        setSalesPagesIndex(state, action) {
            state.salesPagesIndex = action;
        },
        setCurrentBrandName(state, action) {
            state.currentBrandName = action;
        },
        setAgencyName(state, action) {
            state.agencyName = action;
        },
        setEditDealId(state, action) {
            state.editDealId = action;
        },
        setIndexSOW(state, action) {
            state.sow_index = action;
        },
        setIndexUpsell(state, action) {
            state.upsell_index = action;
        },
        setIsEditUpsell(state, action) {
            state.isEditUpsell = action;
        },
        setIsWithoutSOW(state, action) {
            state.isWithoutSOW = action;
        },
        setServicesList(state, action) {
            state.servicesList = action;
        },

        updateSaleInList(state, { deal_index, sale_index, data }) {
            state.salesPages[deal_index].sales[sale_index].eligible_amount =
                data.eligible_amount;
            state.salesPages[deal_index].sales[sale_index].procent =
                data.procent;
            state.salesPages[deal_index].sales[sale_index].commission_owed =
                data.commission_owed;
            if (
                state.salesPages[deal_index].sales[sale_index].hasOwnProperty(
                    "cancel_reason_id"
                )
            ) {
                state.salesPages[deal_index].sales[
                    sale_index
                ].cancel_reason_id = data.cancel_reason_id;
            }

            if (Object.keys(data).length === 5) {
                state.salesPages[deal_index].sales[sale_index][data.key] =
                    data.value;
            }
        },

        updateSaleCancelReasonId(state, { deal_index, sale_index, data }) {
            if (
                state.salesPages[deal_index] &&
                state.salesPages[deal_index].sales[sale_index]
            ) {
                Vue.set(
                    state.salesPages[deal_index].sales[sale_index],
                    "cancel_reason_id",
                    data.value
                );
            }
        },

        incrementDealIndex(state) {
            state.salesPageDealIndex = state.salesPageDealIndex + 1;
        },

        decrementDealIndex(state) {
            state.salesPageDealIndex = state.salesPageDealIndex - 1;
        },

        incrementSaleIndex(state) {
            state.salesPageSaleIndex = state.salesPageSaleIndex + 1;
        },

        decrementSaleIndex(state) {
            state.salesPageSaleIndex = state.salesPageSaleIndex - 1;
        },

        setSaleIndex(state, action) {
            state.salesPageSaleIndex = action;
        },

        setDealIndex(state, action) {
            state.salesPageDealIndex = action;
        },

        setIsHasKickOff(state, action) {
            state.isHasKickOff = action;
        },

        setIsHasUploadLaterSOWs(state, action) {
            state.isHasUploadLaterSOWs = action;
        },

        setIsDealCanceled(state, action) {
            state.isHasDealCanceled = action;
        },

        setIdSLIWithDealCanceled(state, action) {
            state.idSLIWithDealCanceled = action;
        },

        setIndexSLIWithDealCanceled: (state, action) => {
            state.indexSLIWithDealCanceled = action;
        },

        setInitUploadLaterSOWFromQuery: (state, action) => {
            state.initUploadLaterSOWFromQuery = action;
        },
    },
    actions: {},
});

try {
    if (document.getElementById("agency-wizard")) {
        new Vue({
            store,
            render: (h) => h(AgencyWizard),
        }).$mount("#agency-wizard");
    }
} catch (err) {
    console.error("agency-wizard error", err);
}

require("./parts/custom-select");
require("./parts/search-input");
require("./parts/datepicker");
require("./parts/file-picker");
require("./parts/imask");
require("./parts/autocomplete");
require("./parts/sow");
require("./parts/submenu");
require("./parts/referral_partner_url");
require("./parts/openLink");

require("./pages/agency");
require("./pages/brand");
require("./pages/invoice");
require("./pages/invoices");
require("./pages/master-invoices");
require("./pages/deals");
require("./pages/financial-details");
require("./pages/sign-in");

require("./helpers/_check_unsaved");
require("./helpers/_tooltip");
require("./helpers/_openURL");
require("./helpers/_set_quickbook_name");
require("./helpers/_neverEnding");
require("./helpers/_diminishing");
require("./helpers/_checkIsLogged");
